import React from 'react';

import { makeStyles } from '@material-ui/core';

type Props = {
  message: string;
};

const useStyles = makeStyles({
  liveRegion: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1,
  },
});

const LiveRegionStatus: React.FC<Props> = ({ message }) => {
  const styles = useStyles();

  return (
    <div aria-atomic='true' aria-live='polite' className={styles.liveRegion} role='status'>
      {message}
    </div>
  );
};

export default LiveRegionStatus;
